const anetDimebar = "mcc512ad16_anetDimebar";
const anetDimebarAbs = anetDimebar + " " + "mcc512ad16_anetDimebarAbs";
const wrapper = "mcc512ad16_wrapper";
const siteNav = "mcc512ad16_siteNav";
const primaryNav = "mcc512ad16_primaryNav";
const secondaryNav = "mcc512ad16_secondaryNav";
const downloadBtn = "mcc512ad16_downloadBtn";
const anetLogo = "mcc512ad16_anetLogo";
const langSelectBar = "mcc512ad16_langSelectBar";
const currentLang = "mcc512ad16_currentLang";
const hideable = "mcc512ad16_hideable";
export default {
    anetDimebar,
anetDimebarAbs,
wrapper,
siteNav,
primaryNav,
secondaryNav,
downloadBtn,
anetLogo,
langSelectBar,
currentLang,
hideable
};

export {
    anetDimebar,
anetDimebarAbs,
wrapper,
siteNav,
primaryNav,
secondaryNav,
downloadBtn,
anetLogo,
langSelectBar,
currentLang,
hideable
};